export const ItemTypes = {
    GROUP: 'group',
    CARD: 'card'
}